import React, { type ReactElement, type ComponentType } from 'react';
import '@/layout/TwoRowLayout/TwoRowLayout.scss';
import { Col, Container, Row } from 'shared-portal-component';

type Slot = ReactElement | ComponentType<Record<string, unknown>>;

interface TwoRowLayoutProps {
  top: Slot;
  bottom: Slot;
  fillScreen?: boolean;
  className?: string;
}

const TwoRowLayout: React.FC<TwoRowLayoutProps> = ({
  top,
  bottom,
  fillScreen = true,
  className = '',
}) => {
  const renderSlot = (slot: Slot) => {
    if (React.isValidElement(slot)) return slot;
    if (typeof slot === "function") return React.createElement(slot);
    return null;
  };

  return (
    <Container fluid className={`two-row-layout${fillScreen ? ' fill' : ''} ${className}`}>
      {/* Top Row */}
      <Row spacing="md" className="two-row-layout__top">
        <Col size={12}>
          {renderSlot(top)}
        </Col>
      </Row>
      {/* Bottom Row */}
      <Row spacing="md" className="two-row-layout__bottom">
        <Col size={12}>
          {renderSlot(bottom)}
        </Col>
      </Row>
    </Container>
  );
};

export default TwoRowLayout;
